export default {"src":"/_next/static/media/cross.69999775.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};